import {useQuery} from "@tanstack/react-query";
import {useEffect} from "react";
import {getUserDataService} from "../services/account/getUserData";
import {useAuthStore} from "../store/useAuth.store";

const useGetUserInfo = () => {
  const logout = useAuthStore(state => state.logout);

  const {data, isError, isLoading, isSuccess, refetch, error} = useQuery({
    queryKey: ["userData"],
    queryFn: getUserDataService,
    staleTime: 5 * (60 * 1000), // 5 mins
  });

  useEffect(() => {
    if (isError) {
      // When there is an error usually is connected to users with expired token
      // some times when keycloak restarts the tokens are gone from its memory and it needs to refresh
      logout();
    }
  }, [isError, logout]);

  return {data: data?.data?.data, isError, isLoading, isSuccess, refetch, error};
};

export default useGetUserInfo;
